import styled from "styled-components";
import { InputProps } from "./index";
import Colors from "src/general/constants/colors";

export const Button = styled.button<InputProps>`
	width: 100%;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 100%;
	padding: 20px 0;
	background: ${({ background, isActive }) =>
		background ? (isActive ? Colors.PEOPLE_OLD : background) : Colors.DARK_GREY};
	color: ${({ color }) => (color ? color : Colors.DARK_GREY)};
	border: 2px solid
		${({ color, background }) =>
			background === Colors.WHITE ? color : background};
	cursor: ${({ isActive = true }) => (isActive ? "pointer" : "default")};

	&[disabled] {
		opacity: 0.4;
	}
`;
